import { CreditCategory } from "../models/accounting/credit/credit-category";
import { CreditReason } from "../models/accounting/credit/credit-reason";
import { CachedStoreObject } from "../models/utilities/cached-store-object";

/**
 * Credit Entry
 */

        export const ACCOUNTING_CREDIT_PAGEDATA_FETCH           = 'ACCOUNTING_CREDIT_PAGEDATA_FETCH';
        export const ACCOUNTING_CREDIT_CATEGORIES_FETCH_SUCCESS = 'ACCOUNTING_CREDIT_CATEGORIES_FETCH_SUCCESS';
        export const ACCOUNTING_CREDIT_REASONS_FETCH_SUCCESS    = 'ACCOUNTING_CREDIT_REASONS_FETCH_SUCCESS';
        
        /**
         * Action creator for fetching the credit categories
         */
        export const fetchCreditPageData = () => ({
            type: ACCOUNTING_CREDIT_PAGEDATA_FETCH
        });

        /**
         * Action creator for handling the credit category fetch
         * @param result The list of categories and a timestamp
         */
        export const fetchCreditCategoriesSuccess = (result: CachedStoreObject<CreditCategory[]>) => ({
            type: ACCOUNTING_CREDIT_CATEGORIES_FETCH_SUCCESS,
            payload: result
        });

        /**
         * Action creator for handling the credit category fetch
         * @param result The list of categories and a timestamp
         */
        export const fetchCreditReasonsSuccess = (result: CachedStoreObject<CreditReason[]>) => ({
            type: ACCOUNTING_CREDIT_REASONS_FETCH_SUCCESS,
            payload: result
        });
